package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class MessagesSummaryResponse(
  val messages: List<Message>
) {
  @Serializable
  sealed class Message {
    @Serializable
    data class Laboratory(
      val id: String,
      val name: String
    )

    @Serializable
    data class LearnedSociety(
      val id: String,
      val name: String,
      val acronym: String?
    )

    abstract val id: String
    abstract val publishedAt: Instant
    abstract val bannerUrl: String
    abstract val title: String
    abstract val seen: Boolean
    abstract val favorite: Boolean
  }

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.LabodocFlashInfo") // Retrocompat
  data class LabodocFlashInfo(
    override val id: String,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.LaboratoryFlashInfo") // Retrocompat
  data class LaboratoryFlashInfo(
    override val id: String,
    val laboratory: Laboratory,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.LaboratoryInvitation") // Retrocompat
  data class LaboratoryInvitation(
    override val id: String,
    val laboratory: Laboratory,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.MedicineFlashInfo") // Retrocompat
  data class MedicineFlashInfo(
    override val id: String,
    val laboratory: Laboratory,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.MedicineInvitation") // Retrocompat
  data class MedicineInvitation(
    override val id: String,
    val laboratory: Laboratory,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.LearnedSocietyFlashInfo") // Retrocompat
  data class LearnedSocietyFlashInfo(
    override val id: String,
    val learnedSociety: LearnedSociety,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.LearnedSocietyInvitation") // Retrocompat
  data class LearnedSocietyInvitation(
    override val id: String,
    val learnedSociety: LearnedSociety,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()

  @Serializable
  @SerialName("fr.labodoc.api.payloads.responses.HealthProfessionalMessagesSummaryResponse.News") // Retrocompat
  data class News(
    override val id: String,
    val author: String,
    override val publishedAt: Instant,
    override val bannerUrl: String,
    override val title: String,
    val newsUrl: String,
    override val seen: Boolean,
    override val favorite: Boolean
  ) : Message()
}
